import * as React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import './YourPolicy.css'
import { REGISTERUSER } from '../../routes/routes';

class YourPolicy extends React.Component<any, any> {
    public render() {
        return (
            <div className="Rectangle">
                <div className="row red-box">
                    <div className="col-12">
                        <h2 className="Insurance-made-easy">Your policy in <br />your pocket</h2>
                        <div className="li-list">
                            <ul className="Get-instant-cover-fo">
                                <li>Add more items to your policy.</li>
                                <li>Self-inspect your car/motorbike.</li>
                                {this.props.profile.countryId != 157 && <li>Upload your monthly chilli mileage.</li>}
                                <li>Request docs.</li>
                                <li>View your policy info.</li>
                                <li>Change your basic excess.</li>
                                <li>Submit claims.</li>
                            </ul>
                        </div>
                        <div className="mb-5">
                            <h3 className="Not-a-member-yet"> {this.props.profile.countryId != 157 ? "Not a client yet?" : "Not registered yet?"}</h3> 
                            <Link to={REGISTERUSER} className="btn btn-outline-white btn-lg">Sign up now</Link>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return { }
}
export default connect(mapStateToProps, mapDispatchToProps)(YourPolicy);